import React from 'react';

const CheckoutSectionHeader = ({ children, className, align = 'left' }) => (
  <div
    className={`checkout__section-header checkout__section-header--${align} ${
      className ? className : ''
    } `}
  >
    {children}
  </div>
);

export default CheckoutSectionHeader;
